module.exports = "<div ba-panel ba-panel-title=\"{{'Users' | translate}}\" ba-panel-class=\"\">\n    <div class=\"text-right\">\n        <a class=\"btn btn-md btn-primary\" href=\"{{ $ctrl.exportUrl() }}\" translate target=\"_blank\">Export to CSV</a>\n        <a class=\"btn btn-md btn-primary\" ng-click=\"$ctrl.addUser()\" translate >Add User</a>\n    </div>\n    <br>\n    <users-grid initial-params=\"$ctrl.initialParams\" on-params-change=\"$ctrl.onParamsChange(params)\" on-page-change=\"$ctrl.onPageChange($page)\"></users-grid>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsPages/Users/templates/users.html
// module id = 932
// module chunks = 0